import React, { useState, useEffect, useCallback } from 'react';
import { useScore } from '../../context/ScoreProvider';
import '../../styles/QuizScreen.css';

export default function BasicQuizScreen({
  question,
  options,
  onCheckStateChange,
  feedback,
  screenId,
  screenScore
}) {
  const { submitAnswer } = useScore();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleSelect = (option, index) => {
    if (isChecked) return;
    setSelectedOption({ ...option, index });
  };

  const handleCheck = useCallback(() => {
    if (!selectedOption) return;

    setIsChecked(true);
    if (screenScore != null) {
      submitAnswer(screenId, screenScore, selectedOption.correct);
    }
  }, [screenId, screenScore, selectedOption, submitAnswer]);

  useEffect(() => {
    onCheckStateChange?.({
      checked: isChecked,
      canCheck: !!selectedOption,
      onCheck: handleCheck,
    });
  }, [selectedOption, isChecked, handleCheck, onCheckStateChange]);

  const showFeedback =
    isChecked &&
    selectedOption &&
    ((selectedOption.correct && feedback?.correct) ||
     (!selectedOption.correct && feedback?.incorrect));

  const feedbackClass = selectedOption?.correct
    ? 'quiz-feedback-correct'
    : 'quiz-feedback-incorrect';

  const feedbackContent = selectedOption?.correct
    ? feedback?.correct
    : feedback?.incorrect;

  return (
    <div className="basic-quiz quiz-screen">
      <div className={`quiz-card ${showFeedback ? 'blurred' : ''}`}>

        {question && (
          <div
            className={`
              quiz-question
              font-${question?.fontSize ?? 'md'}
              text-${question?.textAlign ?? 'left'}
            `}
            dangerouslySetInnerHTML={{ __html: question.value }}
          />
        )}

        <div className="quiz-options">
          {options.map((option, index) => {
            const isSelected = selectedOption?.index === index;

            let stateClass = '';
            if (isChecked && isSelected) {
              stateClass = option.correct ? 'correct' : 'incorrect';
            } else if (isSelected) {
              stateClass = 'selected';
            }

            return (
              <button
                key={index}
                onClick={() => handleSelect(option, index)}
                className={`quiz-option ${stateClass}`}
              >
                {option.text}
              </button>
            );
          })}
        </div>

        {showFeedback && (
          <div
            className={`quiz-feedback ${feedbackClass}`}
            dangerouslySetInnerHTML={{ __html: feedbackContent }}
          />
        )}

      </div>
    </div>
  );
}
